import {
  getFontCss,
  HoverableLinkSizes,
  styleConstants,
} from '@paywithextend/components'
import React from 'react'
import Popup from 'src/components/Popup/Popup'
import ResourceCenterLink from 'src/components/ResourceCenterLink/ResourceCenterLink'
import Trns from 'src/localization/Trns'
import { css } from 'styled-components'

const ActionUnavailable: React.FC = () => {
  return (
    <Popup
      css={css`
        display: flex;
        flex-direction: column;
      `}
    >
      <span
        css={css`
          ${getFontCss(
            32,
            styleConstants.colors.red,
            styleConstants.fontFamilies.medium,
          )};
          margin-bottom: 40px;
        `}
      >
        <Trns source={'This action is unavailable'} />
      </span>
      <span
        css={css`
          margin-bottom: 20px;
        `}
      >
        <Trns
          source={
            'You need an active account in order to create Virtual Cards or Budgets.'
          }
        />
      </span>
      <span>
        <Trns
          source={
            "Have questions? We're here to help. Visit our ${resourceCenter} for support and contact options."
          }
          expressions={{
            resourceCenter: (
              <ResourceCenterLink
                size={HoverableLinkSizes.Large}
                underline
                regular
              />
            ),
          }}
        />
      </span>
    </Popup>
  )
}

export default ActionUnavailable
